import React, { useContext } from 'react'
import PageContainer from '../containers/PageContainer'
import PrimaryButton from '../buttons/PrimaryButton'
import { Trans, useTranslation } from 'react-i18next'
import LogoutIcon from '@mui/icons-material/Logout';
import { Checkbox } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import useFetch from '../hooks/useFetch';
import { postAcceptTerms } from '../config/apiRoutes';
import UserContext from '../contexts/UserContext';
import AuthContext from '../contexts/AuthContext';
import { termsAndConditionsRoute, usePathReconstructor } from '../config/pageRoutes';

type Props = {}

const AcceptTermsPage = (props: Props) => {
    const { logout } = useContext(AuthContext);
    const { refresh } = useContext(UserContext);
    const { t } = useTranslation();
    const [isTermsChecked, setIsTermsChecked] = React.useState(false);
    const loader = useFetch(false);
    const { copyParamsFromPath } = usePathReconstructor();

    async function handleAcceptTerms() {
        const response = await loader.call("POST", postAcceptTerms);
        if (response.ok) {
            refresh();
        }
    }

    return (
        <div>
            <PageContainer>
                <div className="flex justify-center items-center px-6 pt-10">
                    <div className="bg-secondary-pale w-full md:w-[600px] text-center py-5 px-3">
                        <div className="text-2xl font-bold text-primary-dark">
                            {t("auth.complete_registration")}
                        </div>
                        <div className="flex my-6">
                            <Checkbox
                                style={{ color: "#2E6A73" }}
                                checked={isTermsChecked}
                                onChange={(e) => setIsTermsChecked(e.target.checked)}
                            />
                            <div className="text-left">
                                <Trans
                                    i18nKey={"auth.accept_terms_and_conditions"}
                                    components={{ a: <a target="_blank" className="text-primary hover:underline" href={copyParamsFromPath(termsAndConditionsRoute.path)} /> }}
                                />
                            </div>
                        </div>
                        <div className="my-3">
                            <PrimaryButton
                                variant="strike"
                                fullWidthOnMobile
                                startIcon={<DoneIcon />}
                                disabled={!isTermsChecked}
                                onClick={handleAcceptTerms}
                            >
                                {t("auth.activate_account")}
                            </PrimaryButton>
                        </div>
                        <div className="mt-4">
                            <PrimaryButton
                                variant="outlined"
                                fullWidthOnMobile
                                startIcon={<LogoutIcon />}
                                onClick={() => logout()}
                            >
                                {t("navigation.logout")}
                            </PrimaryButton>
                        </div>
                    </div>
                </div>
            </PageContainer>
        </div>
    )
}

export default AcceptTermsPage